"use client";

import { useEffect } from "react";
import Authenticator from "@/components/auth/Authenticator";
import { useAuthStore } from "@/services/Cognito/authStore";

// this is pretty jank
export const LoginPage = () => {
  const { authenticatorVisible } = useAuthStore();
  // default authenticator to signin on load
  useEffect(() => {
    useAuthStore.setState({
      route: "signIn",
    });
  }, []);

  // this prevents the global authenticator modal from opening
  // this allows the buttons on the navbar to still work here
  useEffect(() => {
    useAuthStore.setState({
      authenticatorVisible: false,
    });
  }, [authenticatorVisible]);
  return <Authenticator />;
};
